export const SESSION_EXPIRED_EVENT = 'peak4:session-expired';

/**
 * Bridges the non-React axios interceptor to the React SessionExpiredDialog.
 * Dispatched on an unrecoverable 401/refresh-failure so the app can prompt a
 * re-login instead of silently redirecting.
 */
export const emitSessionExpired = (): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};
